/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compact } from 'lodash';
import Cookies from 'js-cookie';
import { Dialog, FormGroup, Input, TopNav, PopOver, Switch } from '@tencent/spaui';
import { RPCFactory } from '../../utils/RequestUtil';
import { RegexFactory } from '../../consts/RegexFactory';
import { UserInfoDialogContext } from '../../store/context/userInfoDialogContext';
import { Common } from '../../consts/Common';
import GuideDialog from './GuideDialog';
import { NoticeCenterInHeader } from '../pages/noticeCenter/noticeCenterInHeader';
import Index from '../pages/quickHelpCenter/index';
import { payGuidePrefix as prefix } from '../../consts/prefix';
import { MenuLv1 } from './DispersiveMenu';
import AccountInfoCard from './AccountInfoCard';
import { PayComponent } from './pay/PayComponent';
import { openRiskWarning } from '../pages/quickHelpCenter/store';

const { OverlayTrigger } = PopOver;
const mapDispatchToProps = (dispatch) => ({});
const mapStateToProps = (state) => ({ ...state.system });

const HelpBlockComponent = (props = {}) => {
  const { children, helpBlockClassName = '', helpBlockStyle = {} } = props;
  return (
    <span className={`help-block ${helpBlockClassName}`} style={helpBlockStyle}>
      {children}
    </span>
  );
};

class Header extends React.PureComponent {
  componentDidMount() {
    RPCFactory.operationUser
      .getLoginUserInfo(window.pageProps.uid)
      .done((data) => {
        this.setState({
          // showUpdateOperationDialog: true,
          loginUser: data,
          initQQ: data.qq,
          initWxId: data.wxId,
          initName: data.operationUserName,
          loginUserName: data.operationUserName,
        });
        this.getLeadsReceive();
      })
      .fail((ret, msg) => {});

    RPCFactory.customer
      .getAdUserByUid(window.pageProps.uid)
      .done((data) => {
        if (data) {
          this.setState({ uname: data.companyName });
          window.pageProps.companyName = data.companyName;
          setTimeout(() => {
            const key = prefix + window.pageProps.uid;
            this.setState({ showPayTip: Cookies.get(key) !== 'showed' && localStorage.getItem(key) !== 'showed' });
          }, 1000);
        }
      })
      .fail((ret, msg) => {});

    RPCFactory.tips.get().done((data) => {
      this.setState({
        showTips: data != undefined,
        tipsCode: data == undefined ? '' : data.tipsCode,
      });
    });

    RPCFactory.accountSettings.createQRCode().done((data) => {
      this.setState({ codeUrl: data.qrCodeUrl });
    });
    RPCFactory.noticeCenter
      .getList({
        noticeStatus: 'UNREAD',
        pageIndex: 1,
        pageSize: 5,
      })
      .done((data) => {
        const lastTime = sessionStorage.getItem(prefix + window.pageProps.uid);
        if (data.entities.length && (!lastTime || new Date(lastTime) < new Date(data.entities[0].updateTime))) {
          this.setState({ showNoticeTip: true, noticeInHeaderList: data.entities });
          sessionStorage.setItem(prefix + window.pageProps.uid, data.entities[0].updateTime);
        } else {
          this.setState({ noticeInHeaderList: data.entities });
        }
      });
  }

  constructor(props) {
    super(props);
    this.state = {
      // showUpdateOperationDialog: false,
      loginUser: {},
      uname: '',
      nameError: '',
      telError: '',
      qqError: '',
      wxIdError: '',
      showConfirmDialog: false,
      confirmMessage: '',
      initQQ: '',
      initWxId: '',
      initName: '',
      showTips: true,
      tipsCode: '',
      showQuickHelp: false,
      codeUrl: '',
      noticeInHeaderList: [],
      showNoticeTip: false,
      showStatisticDialog: false,
      payNum: 0,
      payValue: 0,
      shouldPayAmount: 0,
      actualPayAmount: 0,
      noPayAccountIds: [],
      currentPayTime: '',
      payDialogSubmitLabel: '确定',
    };
    this.showPayIcon =
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER';
  }

  onCloseDialog = (event) => {
    // this.setState({ showUpdateOperationDialog: false, showStatisticDialog: false });
    this.setState({ showStatisticDialog: false });
    this.context.setUserInfoDialog(false);
  };

  confirmDialogClose = (event) => {
    this.setState({ showConfirmDialog: false });
  };

  confirmDialogSubmit = (event) => {
    this.setState({ showConfirmDialog: false });
    this.modifyUserInfo();
  };

  showIndividualModal = (event) => {
    this.setState({
      nameError: '',
      telError: '',
      qqError: '',
      wxIdError: '',
    });
    RPCFactory.operationUser
      .getLoginUserInfo(window.pageProps.uid)
      .done((data) => {
        this.setState({
          // showUpdateOperationDialog: true,
          loginUser: data,
          initQQ: data.qq,
          initWxId: data.wxId,
          initName: data.operationUserName,
        });
        this.context.setUserInfoDialog(true);
      })
      .fail((ret, msg) => {
        alert(`请求登录人信息错误，msg:${msg}`);
      });
  };

  onChangeLoginName = (event, value) => {
    const loginUser = { ...this.state.loginUser };
    loginUser.operationUserName = value;
    this.setState({ loginUser });
  };

  onChangeLoginPhone = (event, value) => {
    const loginUser = { ...this.state.loginUser };
    loginUser.phone = value;
    this.setState({ loginUser });
  };

  onChangeLoginQQ = (event, value) => {
    const loginUser = { ...this.state.loginUser };
    loginUser.qq = value;
    this.setState({ loginUser });
  };

  onChangeLoginWxId = (event, value) => {
    const loginUser = { ...this.state.loginUser };
    loginUser.wxId = value;
    this.setState({ loginUser });
  };

  logout = (event) => {
    RPCFactory.sso
      .logout()
      .done((data) => {
        window.location.href = '/';
      })
      .fail((ret, msg) => {
        window.alert(`退出失败，错误信息：${msg}`);
      });
  };

  /**
   * 弹窗个人信息，确认编辑
   * @param event
   */
  onConfigrmUpdateOperationUser = (event) => {
    // 合法性验证
    let isValid = true;

    const { operationUserName, phone, qq, wxId } = this.state.loginUser;

    // 原来没有填qq号，这次填写了
    if (!this.state.initQQ && qq) {
      if (RegexFactory.operationUserQqRegex.test(qq)) {
        this.setState({ qqError: '' });
      } else {
        this.setState({ qqError: '请正确填写QQ号' });
        isValid = false;
      }
    } else {
      this.setState({ qqError: '' });
    }

    // 原来有微信号允许替换或删除
    if (wxId) {
      if (RegexFactory.operationUserWxIdRegex.test(wxId)) {
        this.setState({ wxIdError: '' });
      } else {
        this.setState({ wxIdError: '请正确填写微信号' });
        isValid = false;
      }
    } else {
      this.setState({ wxIdError: '' });
    }

    // 如果没有姓名，则必须填写姓名
    if (!this.state.initName) {
      if (RegexFactory.operationUserNameRegex.test(operationUserName)) {
        this.setState({ nameError: '' });
      } else {
        this.setState({ nameError: '请正确填写姓名' });
        isValid = false;
      }
    }

    if (RegexFactory.operationUserTelRegex.test(phone)) {
      this.setState({ telError: '' });
    } else {
      this.setState({ telError: '请正确填写电话号码' });
      isValid = false;
    }

    if (isValid) {
      // 此用户有微信号，没有qq，这次要绑定qq，需要检测qq是否已经被其他用户绑定
      if (this.state.initWxId && !this.state.initQQ) {
        if (qq) {
          RPCFactory.operationUser
            .checkQQBind(window.pageProps.uid, this.state.loginUser.qq)
            .done((data) => {
              if (data.success) {
                this.setState({
                  showConfirmDialog: true,
                  confirmMessage: '账号绑定成功后，您在腾讯广告各平台的登录信息都将更新，并可用两种方式登录',
                });
              } else {
                this.setState({
                  qqError: data.qqErrorMessage,
                });
              }
            })
            .fail((ret, msg) => {
              alert(`检测qq号接口返回失败，msg:${msg}`);
            });
        } else {
          this.modifyUserInfo();
        }
      } else if (this.state.initQQ) {
        // 原始的有qq号
        if (wxId) {
          if ((this.state.initWxId && this.state.initWxId != wxId) || !this.state.initWxId) {
            RPCFactory.operationUser
              .checkWxIdBind(window.pageProps.uid, this.state.loginUser.wxId)
              .done((data) => {
                if (data.success) {
                  // 这次是重新绑定
                  if (this.state.initWxId && this.state.initWxId != wxId) {
                    this.setState({
                      showConfirmDialog: true,
                      confirmMessage: '账号重新绑定后，您在腾讯广告各平台的登录信息都将更新',
                    });
                  } else if (!this.state.initWxId) {
                    // 这次是第一次绑定微信号
                    this.setState({
                      showConfirmDialog: true,
                      confirmMessage: '账号绑定成功后，您在腾讯广告各平台的登录信息都将更新，并可用两种方式登录',
                    });
                  }
                } else {
                  this.setState({
                    wxIdError: data.wxIdErrorMessage,
                  });
                }
              })
              .fail((ret, msg) => {
                alert(`检测微信号接口返回失败，msg:${msg}`);
              });
          } else {
            this.modifyUserInfo();
          }
        } else {
          if (this.state.initWxId && !wxId) {
            this.setState({
              showConfirmDialog: true,
              confirmMessage: '微信号删除后，您在腾讯广告各平台的登录信息都将更新，仅可用QQ登录',
            });
          } else {
            this.modifyUserInfo();
          }
        }
      } else {
        this.modifyUserInfo();
      }
    }
  };

  modifyUserInfo = () => {
    RPCFactory.operationUser
      .updateLoginUserInfo(
        window.pageProps.uid,
        this.state.loginUser.operationUserName,
        this.state.loginUser.phone,
        this.state.loginUser.qq,
        this.state.loginUser.wxId,
      )
      .done((data) => {
        this.setState({
          loginUserName: this.state.loginUser.operationUserName,
          initQQ: this.state.loginUser.qq,
          initWxId: this.state.loginUser.wxId,
          initName: this.state.loginUser.operationUserName,
        });
        this.setState({ showStatisticDialog: false });
        this.context.setUserInfoDialog(false);
      })
      .fail((ret, msg) => {
        alert(`修改失败，msg:${msg}`);
      });
  };
  getLeadsReceive = () => {
    if (
      this.state.loginUser &&
      this.state.loginUser.operationUserId &&
      (window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE' ||
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER')
    ) {
      RPCFactory.employeeManage
        .getEmployeeById(this.state.loginUser.operationUserId)
        .done((data) => {
          this.setState({
            leadsReceiveStatus: data.leadsReceiveStatus,
          });
        })
        .fail((code, msg) => {
          window.alert(`获取线索接收状态失败，失败信息：${msg}`);
        });
    }
  }
  toggleLeadsReceive = (checked) => {
    checked = checked ? 1 : 0;
    RPCFactory.employeeManage
    .updateLeadsReceiveStatus(this.state.loginUser.operationUserId, checked)
      .done((data) => {
        this.setState({ leadsReceiveStatus: checked });
      })
      .fail((ret, msg) => {
        window.alert(`修改失败，错误信息：${msg}`);
      });
  }
  showQuickHelp = () => {
    this.setState({ showQuickHelp: true });
  };

  hideQuickHelp = () => {
    this.setState({ showQuickHelp: false });
  };

  updateNoticeList = (list) => {
    this.setState({ noticeInHeaderList: list });
  };
  onDownloadPayDetail = () => {
    window.location.href = `${Common.LEADS_PAY_RECORD_DOWNLOAD}?accountId=${window.pageProps.uid}&time=${this.state.seletedPayMonth}`;
  };
  onDisabelTip = () => {
    this.setState({ showPayTip: false });
    localStorage.setItem(prefix + window.pageProps.uid, 'showed');
  };
  render() {
    const { noticeInHeaderList, showNoticeTip } = this.state;
    const NoticeComponent = React.memo((props = {}) => {
      const { className } = props;

      return (
        <li className={`${className} spaui-topnav-drop`}>
          {showNoticeTip ? (
            <a className="nav-link" href="#">
              <i className="spaui-icon icon-nav-inbox-dark-unread"></i>
            </a>
          ) : (
            <a className="nav-link" href="#">
              <i className="spaui-icon icon-nav-inbox-dark"></i>
            </a>
          )}
          <NoticeCenterInHeader list={noticeInHeaderList} updateNoticeList={this.updateNoticeList} />
        </li>
      );
    });
    // 移动版
    const MoComponent = (props = {}) => {
      const { value, className } = props;

      return (
        <li className={`${className} spaui-topnav-drop`}>
          <a className="nav-link" href="#">
            <i className="spaui-icon icon-mo-dark"></i>
          </a>
          <ul className="spaui-topnav-menu mo-card">
            <li className="erweima">
              <div className="erweima-area" style={{ padding: '20px 0' }}>
                <a href="#/system/leadsManageSetting/wechat">扫码绑定微信公众号</a>
                <img src={this.state.codeUrl} alt="" style={{ width: '120px' }} />
              </div>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  this.setState({ showTips: true, tipsCode: 'MobilePublish' });
                }}
                className="mo-text"
              >
                查看移动版上线指引
              </a>
            </li>
          </ul>
        </li>
      );
    };
    // 帮助
    const HelpComponent = (props = {}) => {
      const { value, className } = props;
      return (
        <li className={`${className} spaui-topnav-drop`}>
          <a className="nav-link" href="#">
            帮助
          </a>
          <ul className="spaui-topnav-menu help-card">
            <li className="spaui-topnav-menu-item">
              <a href="#">常见问题</a>
            </li>
            <li className="spaui-topnav-menu-item">
              <a href="#">在线学习</a>
            </li>
            <li className="spaui-topnav-menu-item">
              <a href="#">反馈意见</a>
            </li>
            <li className="spaui-topnav-menu-item">
              <a href="#">咨询客服</a>
            </li>
          </ul>
        </li>
      );
    };
    // 风险提示
    const RiskWarning = (props = {}) => {
      const { className } = props;
      const overlay = (<PopOver>数据安全提示</PopOver>);
      const openTips = (e) => {
        e.preventDefault();
        openRiskWarning();
        this.setState({ showQuickHelp: true });
      };

      return (
        <li className={`${className} spaui-topnav-drop`}>
          <OverlayTrigger
            placement="bottom"
            alignment="center"
            overlay={overlay}
          >
            <a className="nav-link" onClick={openTips}>
              <i className="spaui-icon icon-risk-warning"></i>
            </a>
          </OverlayTrigger>
        </li>
      );
    };
    // 离线任务中心
    const UploadCenter = (props = {}) => {
      const { className } = props;
      const isUploadUnreadDefault = localStorage.getItem('CACHE_IS_UPLOAD_UNREAD') === 'true';
      const [isUnread, setIsUnread] = useState(isUploadUnreadDefault);

      useEffect(() => {
        /**
         * 将组件内部修改组件状态的方法挂载到 window 供外部组件比较方便的使用，但是可能会不太安全
         * 此处这么做的理由是一个其他地方的动画组件在动画完成之后需要修改这个组件的状态
         * 但是由于那个动画是完全脱离 react 使用原生方式实现的，所以这个 react 组件无法感知动画是否完成
         * 所以采取的方式是组件暴露自己的修改状态方法，等动画组件在动画完成之后去调用这个暴露的方法
         * 使用这样的方式来通知组件改变状态
         */
        window._unsafe_set_upload_unread = setIsUnread;
      });

      const iconClass = ['spaui-icon', 'icon-upload-end-target', isUnread ? 'icon-import-unread' : 'icon-import'].join(
        ' ',
      );

      const handleUploadIconClick = (e) => {
        e.preventDefault();
        setIsUnread(false);
        localStorage.removeItem('CACHE_IS_UPLOAD_UNREAD');
        window.location.href = '#/offlineTaskManage';
      };

      return (
        <li className={`${className} spaui-topnav-drop`}>
          <a className="nav-link" href="#/offlineTaskManage" onClick={handleUploadIconClick}>
            <i className={iconClass} />
          </a>
        </li>
      );
    };
    // 反馈中心
    const FeedbackComponent = (props = {}) => {
      const { className } = props;
      return (
        <li className={`${className} spaui-topnav-drop`}>
          <a className="nav-link" href="#">
            <i className="spaui-icon feedback-help"></i>
          </a>
          <ul className="spaui-topnav-menu mo-card">
            <li className="feedback ">
              <a href="https://e.qq.com/feedback/#/?source=8" target="_blank" className="mo-text" rel="noreferrer">
                反馈中心
              </a>
            </li>
          </ul>
        </li>
      );
    };
    const topNavData = {
      title: '线索管理平台',
      logoUrl: 'data:image/svg+xml;base64,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',
      list: [
        {
          placement: 'left',
          value: 'more1',
          data: [],
        },
        {
          placement: 'right',
          value: '',
          data: compact([
            {
              type: 'component',
              component: RiskWarning,
            },
            {
              type: 'component',
              component: UploadCenter,
            },
            this.showPayIcon
              ? {
                  type: 'component',
                  component: PayComponent,
                  className: 'pay-in-nav',
                }
              : false,
            {
              type: 'component',
              component: MoComponent,
            },
            {
              type: 'component',
              component: NoticeComponent,
            },
            {
              type: 'component',
              component: FeedbackComponent,
            },
            {
              type: 'component',
              component: (...props) => (<AccountInfoCard {...props} {...this.state} showIndividualModal={this.showIndividualModal} logout={this.logout} setRouter={this.props.setRouter} />)
            },
          ]),
        },
      ],
    };

    const showSpecialNoPayReasonForADQ = !!this.state.noPayAccountIds && !!this.state.noPayAccountIds.length && !window.pageProps.isMpAdvertiser; // ADQ账户存在确认赔付标签但是未赔付情况
    const showSpecialNoPayReasonForMP = !!this.state.payValue && this.state.noPayAccountIds && !!this.state.noPayAccountIds.length && window.pageProps.isMpAdvertiser; // MP账户存在确认赔付标签但是未赔付的部分账户
    const showCommonNoPayReason = !showSpecialNoPayReasonForADQ && !showSpecialNoPayReasonForMP;
    return (
      <div>
        <div>
          {this.state.tipsCode == 'MobilePublish' && (
            <GuideDialog show={this.state.showTips} tipsCode={this.state.tipsCode} />
          )}
        </div>
        <div className="topnav-container is-fixed-top">
          <TopNav className="topnav" {...topNavData} />
          <MenuLv1 />
        </div>
        <Dialog
          type="normal"
          className="spaui-dialog-confirm-normal"
          backdrop
          enabledBackdropClose
          show={this.state.showConfirmDialog}
          onClose={this.confirmDialogClose}
          onSubmit={this.confirmDialogSubmit}
          onCancel={this.confirmDialogClose}
        >
          <div>{this.state.confirmMessage}</div>
        </Dialog>
        <Dialog
          show={this.context.showUserInfoDialog}
          onClose={this.onCloseDialog}
          onCancel={this.onCloseDialog}
          backdrop
          type="normal"
          style={{ width: '400px' }}
          className=""
          onSubmit={this.onConfigrmUpdateOperationUser}
          title="个人设置"
        >
          <div className="">
            <div className="configs">
              <ul className="config-list">
                <li className="config-li">
                  <p className="name">姓名</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.nameError ? 'error' : 'normal'}
                      helpBlock={this.state.nameError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        value={this.state.loginUser.operationUserName}
                        onChange={this.onChangeLoginName}
                        placeholder="请输入姓名"
                        disabled={!!this.state.initName}
                      />
                    </FormGroup>
                  </div>
                </li>
                <li className="config-li login-nums">
                  <p className="name">登录账号</p>
                  <div className="form-in">
                    <p className="form-in-tt">QQ:</p>
                    <FormGroup
                      status={this.state.qqError ? 'error' : 'normal'}
                      helpBlock={this.state.qqError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        value={this.state.loginUser.qq}
                        onChange={this.onChangeLoginQQ}
                        placeholder="请输入QQ号，可用于登录"
                        disabled={!!this.state.initQQ}
                      />
                    </FormGroup>
                  </div>
                  <div className="form-in">
                    <p className="form-in-tt">微信:</p>
                    <FormGroup
                      status={this.state.wxIdError ? 'error' : 'normal'}
                      helpBlock={this.state.wxIdError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        value={this.state.loginUser.wxId}
                        onChange={this.onChangeLoginWxId}
                        placeholder="请输入微信号，可用于登录"
                        disabled={!!(this.state.initWxId && !this.state.initQQ)}
                      />
                    </FormGroup>
                  </div>
                </li>
                <li className="config-li">
                  <p className="name">电话号码（用于电话外呼）</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.telError ? 'error' : 'normal'}
                      helpBlock={this.state.telError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        value={this.state.loginUser.phone}
                        onChange={this.onChangeLoginPhone}
                        placeholder="请输入电话号码"
                      />
                    </FormGroup>
                  </div>
                </li>
                {(window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE'
                || window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER') && (<li className="config-li">
                  <span className="leads-receive-switch">
                    线索接收状态
                    <Switch
                      key={this.state.leadsReceiveStatus}
                      checked={this.state.leadsReceiveStatus}
                      onChange={(event, checked) => {
                        this.toggleLeadsReceive(checked);
                      }}
                    ></Switch>
                  </span>
                </li>)}
              </ul>
            </div>
          </div>
        </Dialog>
        <div className="main">
          <div className="helper" onClick={this.showQuickHelp}></div>
          <Index show={this.state.showQuickHelp} hideQuickHelp={this.hideQuickHelp} />
        </div>
      </div>
    );
  }
}
Header.contextType = UserInfoDialogContext;
const ReduxHeader = connect(mapStateToProps, mapDispatchToProps)(Header);
export default ReduxHeader;
